import "./App.css";
import { useState, useEffect } from "react";
import styled from "styled-components";

import img from "./img/bg.gif";
import bird from "./img/bird.gif";

const BIRD_SIZE = 50;
const GAME_WIDTH = 600;
const GAME_HEIGHT = 500;
const GRAVITY = 6;
const JUMP_HEIGHT = 75;
const OBSTACLE_WIDTH = 40;
const OBSTACLE_GAP = 200;

function App() {
  const [birdPosition, setbirdPosition] = useState(250);
  const [gameHasStarted, setGameHasStarted] = useState(false);
  const [obstacleHeight, setObstacleHeight] = useState(100);
  const [obstacleLeft, setObstacleLeft] = useState(GAME_WIDTH - OBSTACLE_WIDTH);
  const [score, setScore] = useState(0);

  const bottomObstacleHeight = GAME_HEIGHT - OBSTACLE_GAP - obstacleHeight;

  useEffect(() => {
    let timeId;
    if (gameHasStarted && birdPosition < GAME_HEIGHT - BIRD_SIZE) {
      timeId = setInterval(() => {
        setbirdPosition((prev) => prev + GRAVITY);
      }, 24);
    }
    return () => {
      clearInterval(timeId);
    };
  }, [gameHasStarted, birdPosition]);

  useEffect(() => {
    let obstacleId;
    if (gameHasStarted && obstacleLeft >= -OBSTACLE_WIDTH) {
      obstacleId = setInterval(() => {
        setObstacleLeft((obstacleLeft) => obstacleLeft - 8);
      }, 24);

      return () => {
        clearInterval(obstacleId);
      };
    } else {
      setObstacleLeft(GAME_WIDTH - OBSTACLE_WIDTH);
      setObstacleHeight(
        Math.floor(Math.random() * (GAME_HEIGHT - OBSTACLE_GAP))
      );
      if (gameHasStarted) setScore((score) => score + 1);
    }
  }, [gameHasStarted, obstacleLeft]);

  useEffect(() => {
    const hasCollidedWithTopObstacle =
      birdPosition >= 0 && birdPosition < obstacleHeight;
    const hasCollidedWithBottomObstacle =
      birdPosition <= 500 && birdPosition >= 500 - bottomObstacleHeight;
    if (
      obstacleLeft >= 0 &&
      obstacleLeft <= OBSTACLE_WIDTH &&
      (hasCollidedWithTopObstacle || hasCollidedWithBottomObstacle)
    ) {
      setGameHasStarted(false);
      setScore(0);
    }
  }, [birdPosition, obstacleHeight, bottomObstacleHeight, score, obstacleLeft]);

  const handleClick = () => {
    let newBirdPosition = birdPosition - JUMP_HEIGHT;
    if (!gameHasStarted) setGameHasStarted(true);
    if (birdPosition < 0) {
      setbirdPosition(0);
    } else {
      setbirdPosition(newBirdPosition);
    }
  };

  return (
    <Container>
      <Div onClick={handleClick}>
        <GameBox height={GAME_HEIGHT} width={GAME_WIDTH}>
          <Obstacle
            left={obstacleLeft}
            top={0}
            width={OBSTACLE_WIDTH}
            height={obstacleHeight}
          />
          <Obstacle
            left={obstacleLeft}
            top={GAME_HEIGHT - (obstacleHeight + bottomObstacleHeight)}
            width={OBSTACLE_WIDTH}
            height={bottomObstacleHeight}
          />
          <Bird size={BIRD_SIZE} top={birdPosition} />
        </GameBox>
        <span></span>
        <TradeMark>Score : {score}</TradeMark>
        <TradeMark2> Ristiawan &#169; 2023</TradeMark2>
      </Div>
    </Container>
  );
}

export default App;

const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ccffff;
`;

const TradeMark = styled.div`
  position: absolute;
  top: 450px;
  color: white;
  font-size: 17px;
`;

const TradeMark2 = styled.div`
  position: absolute;
  top: 470px;
  margin-top: 2px;
  color: white;
  font-size: 12px;
`;

const Bird = styled.div`
  position: absolute;
  background-image: url(${bird});
  transform: scaleX(-1);
  background-size: cover;
  background-position: center center;
  height: ${(props) => props.size}px;
  width: ${(props) => props.size}px;
  top: ${(props) => props.top}px;
`;

const Div = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  & span {
    color: white;
    font-size: 24px;
    position: absolute;
  }
`;

const GameBox = styled.div`
  height: ${(props) => props.height}px;
  width: ${(props) => props.width}px;
  background-image: url(${img});
  background-size: cover;
  background-position: center center;
  background-color: blue;
  overflow: hidden;
`;

const Obstacle = styled.div`
  position: relative;
  transform: translateX(-50%);
  box-shadow: 0 8px 10px rgba(0, 0, 0, 0.5);
  background: linear-gradient(
    to right,
    #579c66,
    #579c66 5px,
    #6dad7b 15px,
    #e9ffe8 33px,
    #9dd591 50px,
    #6bb765 100px,
    #142e16 100%
  );

  &::before {
    content: "";
    position: absolute;
    z-index: 1;
    left: -10px;
    height: 8px;
    border-radius: 6px 6px 0 0;
    background: linear-gradient(
      to bottom,
      rgba(255, 255, 255, 0.3),
      rgba(255, 255, 255, 0.1) 98%,
      rgba(255, 255, 255, 0.1) 100%
    );
  }
  &::after {
    content: "";
    position: absolute;
    left: -10px;
    height: 50px;
    border-radius: 6px;
    border-bottom: solid 7px rgba(0, 0, 0, 0.4);
    box-shadow: 0 4px 5px rgba(0, 0, 0, 0.5);
    background: linear-gradient(
      to right,
      #579c66,
      #579c66 5px,
      #6dad7b 18px,
      #e9ffe8 36px,
      #9dd591 53px,
      #6bb765 103px,
      #142e16 100%
    );
  }
  height: ${(props) => props.height}px;
  width: ${(props) => props.width}px;
  top: ${(props) => props.top}px;
  left: ${(props) => props.left}px;
  background-color: green;
`;
